import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {ExamenDefinitionModel} from "../../../api/entity/examenDefinition.model";
import {ExamenDefinitionConverter} from "../../../api/entity/converter/examenDefinition.converter";
import {AbstractDataServiceV2} from "../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable()
export class ExamenDefinitionDataService extends AbstractDataServiceV2<ExamenDefinitionModel, ExamenDefinitionConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: ExamenDefinitionConverter) {
        super('ExamenDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}
